import { IconPoint } from '@tabler/icons-react'
import React from 'react'
import { formatDate } from '../Utils/helpers/commonhelper'

export const MeetingCard = ({
    meeting,
    showMoreIndicator,
    moreCount,
    cardColor,
    onClickMeetingCard,
    selectedMeetingId,
    invitees,
    meetingCategory
}) => {

    const getStableAvatar = (invitee, idx) => {
        const seed = invitee.email || invitee.id || idx
        return `https://i.pravatar.cc/40?img=${(Math.abs(
            seed
                .toString()
                .split("")
                .reduce((a, b) => a + b.charCodeAt(0), 0)
        ) % 10) + 1}`
    }
    return (
        <div
            key={meeting.id}
            className={`meeting-card position-relative  ${selectedMeetingId === meeting.id
                ? "shadow-sm"
                : ""
                }`}
            style={{
                backgroundColor: cardColor,
                cursor: "pointer",
                border:
                    selectedMeetingId === meeting.id
                        ? cardColor === "#f5f4fe"
                            ? "2px solid #c5beff80"
                            : "2px solid #ffc0b380"
                        : "1px solid #efefef",
                transition: "border 0.2s ease-in-out",
            }}
            onClick={onClickMeetingCard}
        >
            <div className="meeting-info" >
                <h4
                    className="meeting-title"
                    style={{ textTransform: "capitalize", cursor: 'pointer', fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
                >
                    {meeting.meeting_title}
                </h4>
                <span className="meeting-time">
                    {meetingCategory === "current" ? "Today" : formatDate(meeting.meeting_date)}
                    <IconPoint
                        style={{ stroke: "grey", fill: "grey" }}
                        size={12}
                    />{" "}
                    {meeting.meeting_from} - {meeting.meeting_to}
                </span>
            </div>
            <div className="meeting-details">
                <div className="meeting-platform">
                    <img
                        src="https://www.gstatic.com/images/branding/product/1x/meet_2020q4_48dp.png"
                        alt="Google Meet"
                        className="meeting-platform-icon"
                    />
                    <span className="meeting-platform-text">
                        {meeting.meeting_type === "virtual"
                            ? "Google Meet"
                            : "In-Person"}
                    </span>
                </div>

                <div className="meeting-attendees">
                    {invitees.slice(0, 5).map((invitee, index) => (
                        <img
                            key={invitee.id || `avatar-${index}`}
                            src={getStableAvatar(invitee, index)}
                            alt={`Avatar ${index + 1}`}
                            className="meeting-avatar"
                            title={invitee.fullName || invitee.email}
                        />
                    ))}
                    {showMoreIndicator && (
                        <div className="meeting-more-attendees">
                            <span className="meeting-more-count">
                                +{moreCount}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
